import Menu from './menu';
import {TweenMax} from "gsap/esm/TweenMax";

export default class MenuDesktop extends Menu {
    constructor(...args) {
        super(...args);

        this.height = 120;
        this.scrollY = 100;
    }

    _open() {
        // Display Menu DOM
        this.dom.btnMenu.classList.add('active');
        this.dom.component.classList.add('show');

        // Anim Backgrounds Cols
        setTimeout(()=>{
            this.dom.component.classList.add('anim-cols');
            this._canClick = true;
            TweenMax.staggerTo(this.dom.itemMenu, 0.5, {
                autoAlpha: 1
            }, 0.15);
        }, 200);

        TweenMax.to(this.dom.footer, 0.2, {autoAlpha: 1});
    }

    _close() {
        this.dom.btnMenu.classList.remove('active');
        this.dom.component.classList.remove('anim-cols');

        TweenMax.to(this.dom.footer, 0.2, {autoAlpha: 0});

        TweenMax.staggerTo(this.dom.itemMenu, 0.5, {
            autoAlpha: 0
        }, 0.15);

        // Anim Backgrounds Cols
        setTimeout(()=>{
            // Hide Menu DOM
            this.dom.component.classList.remove('show');
            this._canClick = true;
        }, 1000);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/menu/menu.desktop.js